<template>
    <div class="dashboard">
        <h1>Report Dashboard</h1>
        <b-card footer-class="p-0">
            <b-card-group deck>
                <b-card no-body class="border-0">
                    <total-active-patients />
                </b-card>
                <b-card no-body class="border-0">
                    <total-active-clients />
                </b-card>
                <b-card no-body class="border-0">
                    <total-appointment />
                </b-card>
            </b-card-group>
            <template v-slot:footer>
                <b-tabs
                    card
                    class="list"
                    v-model="activeTabIndex"
                    ref="btabs"
                    @input="onTabInput"
                >
                    <tab-schedule button-id="tab-schedule" />
                    <tab-patient button-id="tab-patient" />
                    <tab-client button-id="tab-client" />
                    <tab-communication button-id="tab-communication" />
                    <tab-contact button-id="tab-contact" />
                    <tab-inventory button-id="tab-inventory" />
                    <tab-billing button-id="tab-billing" />
                    <tab-staff button-id="tab-staff" />
                    <tab-wellness
                        v-if="isWellnessPlanEnabled()"
                        button-id="tab-wellness"
                    />
                    <tab-custom-report
                        v-if="hasCustomReport"
                        button-id="tab-custom-report"
                    />
                    <tab-scheduled-report
                        v-if="isCanViewScheduledReport"
                        button-id="tab-scheduled-report"
                    />
                </b-tabs>
            </template>
        </b-card>
    </div>
</template>
<script>
import "@/jquery/jquery.flot";
import totalActivePatients from "./module/patient/total_active_patients";
import totalActiveClients from "./module/client/total_active_clients";
import totalAppointment from "./module/client/total_appointments";
import { TABS, TAB_STRING } from "@/constants/tab-report";

export default {
    components: {
        totalActivePatients,
        totalActiveClients,
        totalAppointment,
        tabSchedule: () => import("@/module/report/tabs/tab-schedule.vue"),
        tabPatient: () => import("@/module/report/tabs/tab-patient.vue"),
        tabClient: () => import("@/module/report/tabs/tab-client.vue"),
        tabCommunication: () =>
            import("@/module/report/tabs/tab-communication.vue"),
        tabContact: () => import("@/module/report/tabs/tab-contact.vue"),
        tabInventory: () => import("@/module/report/tabs/tab-inventory.vue"),
        tabBilling: () => import("@/module/report/tabs/tab-billing.vue"),
        tabStaff: () => import("@/module/report/tabs/tab-staff.vue"),
        tabWellness: () => import("@/module/report/tabs/tab-wellness.vue"),
        tabCustomReport: () =>
            import("@/module/report/tabs/tab-custom-report.vue"),
        tabScheduledReport: () =>
            import("@/module/report/tabs/tab-scheduled-report.vue")
    },
    computed: {
        isCanViewScheduledReport() {
            return this._hasAccess("report.scheduled_reports.view");
        }
    },
    created() {},
    mounted() {
        this.pendingTabActivation = this.getTabIndex();
        if (this.pendingTabActivation === undefined) {
            this.changeRoute(TAB_STRING.SCHEDULE);
        }
        this.activeTabIndex = 0;
        this.checkHasCustomReport();
    },
    data() {
        return {
            hasCustomReport: true,
            activeTabIndex: null,
            pendingTabActivation: null,
            TABS,
            isChangeRoute: false,
            triggered: 0
        };
    },
    watch: {
        "$route.query.tab"() {
            if (!this.isChangeRoute) {
                this.loadTab();
            }
            this.isChangeRoute = false;
        }
    },
    methods: {
        async onTabInput(val) {
            if (val !== -1 && this.pendingTabActivation !== null) {
                // Upon on report dashboardpage load
                // The value is 0 and pendingTabActivation is not null which means the tab is just rendered
                await this._getSetting(); // Wait for render hasAccess
                this.activeTabIndex = this.pendingTabActivation;
                this.pendingTabActivation = null;
            } else if (this.pendingTabActivation === null && val >= 0) {
                // Change the tab manually from report dashboard or left navigation
                if (val == 0) {
                    this.changeRoute(TAB_STRING.SCHEDULE);
                } else if (val == 1) {
                    this.changeRoute(TAB_STRING.PATIENTS);
                } else if (val == 2) {
                    this.changeRoute(TAB_STRING.CLIENTS);
                } else if (val == 3) {
                    this.changeRoute(TAB_STRING.COMMUNICATIONS);
                } else if (val == 4) {
                    this.changeRoute(TAB_STRING.CONTACTS);
                } else if (val == 5) {
                    this.changeRoute(TAB_STRING.INVENTORY);
                } else if (val == 6) {
                    this.changeRoute(TAB_STRING.BILLING);
                } else if (val == 7) {
                    this.changeRoute(TAB_STRING.STAFF);
                } else if (val == 8) {
                    this.changeRoute(TAB_STRING.WELLNESS_PLAN);
                } else if (val == 9) {
                    this.changeRoute(TAB_STRING.CUSTOM);
                } else if (val == 10) {
                    this.changeRoute(TAB_STRING.SCHEDULED_REPORT);
                }
            }
        },
        async loadTab() {
            await this._getSetting(); // wait for render hasAccess
            const tab = this.getTabIndex();
            if (tab !== -1) {
                this.activeTabIndex = tab;
            }
        },
        getTabIndex() {
            if (this.$route.query.tab) {
                const tab = TABS[this.$route.query.tab.toLowerCase()];
                return tab;
            }
            return undefined;
        },
        isWellnessPlanEnabled() {
            let self = this;
            let status = false;
            _.forEach(self.$root._data.extensions, function (data) {
                if (
                    data.extension_code == "WELLNESS" &&
                    data.status == "ENABLED"
                ) {
                    status = true;
                }
            });
            return status;
        },
        checkHasCustomReport() {
            let self = this;
            let countPublishCustomReports = 0;

            return this.$http
                .get(
                    process.env.BARRACUDA +
                        "report/count-publish-custom-reports"
                )
                .then(function (response) {
                    countPublishCustomReports = parseInt(
                        response.data.response.resources
                    );
                    if (countPublishCustomReports <= 0) {
                        self.hasCustomReport = false;
                    } else {
                        self.hasCustomReport = true;
                    }
                });
        },
        changeRoute(tab) {
            if (this.$route.fullPath !== `/report/dashboard?tab=${tab}`) {
                this.isChangeRoute = true;
                this.$router.push(`/report/dashboard?tab=${tab}`);
            }
        }
    }
};
</script>
